/*
 * @Author: wzh
 * @LastEditTime: 2022-11-01 15:31:12
 * @Description: 用户信息防遗忘 index
 */
import Forgotten from "./forgotten";
export { Forgotten };
